import(/* webpackMode: "eager" */ "/alias/app/global-error.tsx")